import { Box, CircularProgress } from '@mui/material';

export const FullPageLoader = () => {
  return (
    <Box
      sx={{
        position: 'absolute',
        inset: 0,
        width: '100vw',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.3)',
        backdropFilter: 'blur(10px)',
        zIndex: 500,
      }}
    >
      <CircularProgress />
    </Box>
  );
};
